import React from 'react'
import * as E from '../elementor'
import parse from 'html-react-parser'

interface Props {
  section?: E.Section
  theme?: string
  template?: string
}

const SimpleBanner: React.FC<Props> = ({ section, theme, template }) => {
  const { textEditor = [], button = [] } = (section != null) ? E.collect(section) : {}
  const bannerTextClass = template === 'therapy-type' ? 'paragraph-large-bold' : 'paragraph'
  
  return (
    <div className='simple-banner' data-theme={theme}>
      <div className='banner-text'>
        <p className={bannerTextClass}>{parse(textEditor[0]?.text()) || ''}</p>
      </div>
      <a id={ button[0]?.button_css_id || ''} href={button[0].link} className='banner-button rula-secondary-button'>
        {button[0].text}
        <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <g id='arrow-narrow-right' clipPath='url(#clip0_3710_5260)'>
            <path id='Icon' d='M0.1875 10H13.5208M13.5208 10L8.52083 5M13.5208 10L8.52083 15' stroke-width='1.66667' stroke-linecap='round' stroke-linejoin='round' />
          </g>
          <defs>
            <clipPath id='clip0_3710_5260'>
              <rect width='20' height='20' fill='white' transform='translate(0.666992)' />
            </clipPath>
          </defs>
        </svg>
      </a>
    </div>
  )
}

export default SimpleBanner
